import { IGatsbySvg } from "@bond-london/gatsby-transformer-extracted-svg";
import { IRichTextInformation } from "@bond-london/graphcms-rich-text";
import classNames from "classnames";
import React from "react";
import { RTF } from "../elements/RTF";

export const Feature: React.FC<{
  title?: string;
  message?: IRichTextInformation;
  shape?: IGatsbySvg;
}> = ({ title, message, shape }) => {
  return (
    <section data-component="Feature" className="py-section relative bg-cotton">
      <div className="page-grid max-width relative">
        {shape && (
          <img
            className={classNames(
              "hidden",
              "md:col-span-4 md:col-start-1 md:block",
              "md:row-span-3 md:row-start-1 lg:col-span-5 lg:col-start-1",
            )}
            src={shape.encoded ?? shape.encodedUrl}
            alt=""
          />
        )}
        {title && (
          <h2
            className={classNames(
              "h2 text-coal",
              "col-span-4 col-start-2",
              "md:col-span-6 md:col-start-2 md:row-start-2",
              "lg:col-span-5 lg:col-start-3",
            )}
          >
            {title}
          </h2>
        )}
        {message && (
          <RTF
            content={message}
            className={classNames(
              "col-span-4 col-start-2",
              "md:col-span-5 md:col-start-5 md:row-start-2",
              "lg:col-span-7 lg:col-start-8",
            )}
          />
        )}
      </div>{" "}
    </section>
  );
};
